import { Component, OnInit } from '@angular/core';
import {Message} from 'primeng/primeng';
import {ConfirmationService} from 'primeng/primeng';
import {SelectItem} from 'primeng/primeng';
import {ProtocolService} from '../services/protocol.service';
import {ProtocolCommandService} from '../services/protocol-command.service';

@Component({
  selector: 'app-protocol',
  templateUrl: './protocol.component.html',
  styleUrls: ['./protocol.component.css'],
  providers: [ConfirmationService]
})
export class ProtocolComponent implements OnInit {

  msgs: Message[] = [];
  protocol: any;
  protocols : any [];
  protocolCommands: any[];
  displayAdd: boolean = false;
  displayEdit: boolean = false;
  displayEditCommand: boolean = false;
  displayCommands: boolean = false;
  status: SelectItem[];
  blockedDocument: boolean = false;
  displayAddCommand: boolean = false;
  protocolCommand: any;
  types: SelectItem[];

  constructor(private protocolService : ProtocolService,private confirmationService: ConfirmationService, private protocolCommandService:ProtocolCommandService) { }

  ngOnInit() {
    this.init();
    this.status = [
      {label: 'Habilitado', value: 'H', icon: 'fa fa-check-square-o'},
      {label: 'Inhabilitado', value: 'I', icon: 'fa fa-square-o'}
    ];

    this.types = [
      {label: 'Desbloqueado', value: 'UNLOCKED'},
      {label: 'Bloqueado', value: 'LOCKED'},
      {label: 'Actualizar Posición', value: 'POSITION'}
    ];
  }
  init(){
    this.protocols = [];
    this.protocolService.findAll().then(data => {
      let response: any = data;
      response.protocols.forEach(item => {
        this.protocols.push(item);
      });
    }).catch(err =>{
      this.msgs = [{severity:'error', summary:'ERROR', detail:err}];
    });
    this.protocol = {status:"H"};
    this.protocolCommand = {};
    this.displayAdd = false;
    this.displayEdit = false;
    this.displayCommands = false;
  }

  showAdd(){
    this.displayAdd = true;
  }

  showEdit(protocol:any){
    this.protocol=protocol;
    this.displayEdit = true;
  }

  showCommands(idProtocol:number){
    this.protocolCommand = {idProtocol:idProtocol};
    this.displayCommands = true;
    this.protocolCommands = [];
    this.protocolCommandService.findByProtocol(idProtocol).then(data => {
      let response: any = data;
      response.protocolCommands.forEach(item => {
        this.protocolCommands.push(item);
      });
    }).catch(err =>{
      console.log(err);
      this.msgs = [{severity:'error', summary:'ERROR', detail:err}];
    });
    this.hideCommand();
  }

  hide(){
    this.protocol = {status:"H"};
    this.displayAdd = false;
    this.displayEdit = false;
    this.displayCommands = false;

  }

  hideCommand(){
    this.protocolCommand = {idProtocol:this.protocolCommand.idProtocol};
    this.displayAddCommand = false;
    this.displayEditCommand = false;
  }

  add(){
    this.blockedDocument = true;
    this.protocolService.create(this.protocol).then(data =>{
      let response: any = data;
      if(response.status == 'OK'){
        this.init();
        this.msgs = [{severity:'info', summary:'INFO', detail:'Registro insertado exitosamente'}];
      }else{
        this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
      }
      this.blockedDocument = false;
    }).catch(err =>{
      this.msgs = [{severity:'error', summary:'ERROR', detail:err}];
      this.blockedDocument = false;
    });
  }

  edit(){
    this.blockedDocument = true;
    this.protocolService.edit(this.protocol).then(data =>{
      let response: any = data;
      if(response.status == 'OK'){
        this.init();
        this.msgs = [{severity:'info', summary:'INFO', detail:'Registro modificado exitosamente'}];
      }else{
        this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
      }
      this.blockedDocument = false;
    }).catch(err =>{
      this.msgs = [{severity:'error', summary:'ERROR', detail:err}];
      this.blockedDocument = false;
    });
  }

  del(id: number){
    this.confirmationService.confirm({
      message: 'Esta seguro de eliminar el registro seleccionado?',
      header: 'Confirmación',
      icon: 'fa fa-trash',
      accept: () => {
        this.blockedDocument = true;
        this.protocolService.remove(id).then(data =>{
          let response: any = data;
          if(response.status == 'OK'){
            this.init();
            this.msgs = [{severity:'info', summary:'INFO', detail:'Registro eliminado exitosamente'}];
          }else{
            this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
          }
          this.blockedDocument = false;
        }).catch(err =>{
          this.msgs = [{severity:'error', summary:'ERROR', detail:err}];
          this.blockedDocument = false;
        });
      }
    });
  }

  showAddCommand(){
    this.displayAddCommand = true;
  }

  showEditCommand(protocolCommand:any){
    this.protocolCommand=protocolCommand;
    this.displayEditCommand = true;
  }

  addCommand(){
    this.blockedDocument = true;
    this.protocolCommandService.create(this.protocolCommand).then(data =>{
      let response: any = data;
      if(response.status == 'OK'){
        this.showCommands(this.protocolCommand.idProtocol);
        this.msgs = [{severity:'info', summary:'INFO', detail:'Registro insertado exitosamente'}];
      }else{
        this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
      }
      this.blockedDocument = false;
    }).catch(err =>{
      this.msgs = [{severity:'error', summary:'ERROR', detail:err}];
      this.blockedDocument = false;
    });
  }

  editCommand(){
    this.blockedDocument = true;
    this.protocolCommandService.edit(this.protocolCommand).then(data =>{
      let response: any = data;
      if(response.status == 'OK'){
        this.showCommands(this.protocolCommand.idProtocol);
        this.msgs = [{severity:'info', summary:'INFO', detail:'Registro modificado exitosamente'}];
      }else{
        this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
      }
      this.blockedDocument = false;
    }).catch(err =>{
      this.msgs = [{severity:'error', summary:'ERROR', detail:err}];
      this.blockedDocument = false;
    });
  }

  delCommand(idProtocol: number,type: string){
    this.confirmationService.confirm({
      message: 'Esta seguro de eliminar el registro seleccionado?',
      header: 'Confirmación',
      icon: 'fa fa-trash',
      accept: () => {
        this.blockedDocument = true;
        this.protocolCommandService.remove(idProtocol,type).then(data =>{
          let response: any = data;
          if(response.status == 'OK'){
            this.showCommands(idProtocol);
            this.msgs = [{severity:'info', summary:'INFO', detail:'Registro eliminado exitosamente'}];
          }else{
            this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
          }
          this.blockedDocument = false;
        }).catch(err =>{
          this.msgs = [{severity:'error', summary:'ERROR', detail:err}];
          this.blockedDocument = false;
        });
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/protocol/protocol.component.ts